const COMMON = {
  API_ERROR: "알 수 없는 오류가 발생했습니다.",
  LOGIN: "로그인 후 확인 가능합니다.",
  JOIN_APPROVAL: "가입승인 완료 후 확인 가능합니다.",
  AGREE_PRIVACY_POLICY: "개인정보 수집 및 이용에 동의해 주세요.",
  INPUT_EMAIL: "이메일을 입력해 주세요.",
  INPUT_RIGHT_EMAIL: "올바른 이메일을 입력해주세요.",
  WITHDRAWN: "개인정보 및 사업장 전체 삭제 상태로, PC방 목록을 확인할 수 없습니다.",
};

const MANAGEMENT = {
  INPUT_SEAT_NUMBER: "자리번호를 입력해주세요.",
  CHANGE_DUPLIDATE_NUMBER: "자리번호가 중복 되어, 중복된 {n}번호는 가장 마지막 번호로 변경됩니다.",
  INPUT_RIGHT_IP: "올바른 IP 주소를 입력해 주세요.",
  INPUT_RIGHT_IP2: "올바른 IP 형식의 주소를 입력해 주세요.",
  SUBMIT: "변경 사항이 저장 되었습니다.",
  DELETE_ACTIVE_BILLING: "G코인 과금 설정을 비활성화한 IP만 삭제 가능합니다.",
  DELETE_IP: "IP를 삭제하시겠습니까?",
  DELETE_SELECTED_IP: "선택한 IP를 삭제하시겠습니까?",
  SELECT_DELETE_IP: "삭제할 IP를 선택해 주세요.",
  MAX_LENGTH_IP: "IP 일괄 등록은 한 번에 최대 100개까지 가능합니다.",
  EMPTY_IP_LENGTH: "추가할 IP 개수를 입력해 주세요.",
};

const PRODUCT = {
  CANCEL_PAYMENT: "해당 내역을 결제 승인 취소 하시겠습니까?",
  CANCLE_PAYMENT_SUCCESS: "결제 취소 되었습니다.",
  APPLY_ACTIVE_BILLING: "G코인 과금 설정을 비활성화 한 후 신청 가능합니다.",
  CHECK_COMPLETED: "확인 되었습니다.",
  RECHECK_CONTENT: "입력 사항을 확인 후 다시 계좌 확인 버튼을 선택해 주세요.",
  SELECT_BANK: "입금 은행을 선택해 주세요.",
  INPUT_ACCOUNT_NUMBER: "계좌번호를 입력해 주세요.",
  INPUT_TARGET_NAME: "예금주를 입력해 주세요.",
  CLICK_ACCOUNT_BUTTON: "계좌 확인 버튼을 선택해 주세요.",
  INPUT_PHONE_NUMBER: "연락처를 입력해 주세요.",
  ALREADY_USEDED_COUPON: "이미 사용한 쿠폰입니다.",
  CHECK_COUPON: "쿠폰번호를 확인해 주세요.",
  CHECK_COUPON_DATE: "쿠폰 유효기간을 확인해 주세요.",
  CANCEL_AUTOMATIC_PAYMENT: "자동결제를 해지하시겠습니까?",
  CANCEL_AUTOMATIC_PAYMENT_SUCCESS: "자동결제가 취소되었습니다.",
};

const HELPDESK = {
  CANCEL_WRITE: "작성중인 내용이 모두 삭제됩니다. 작성을 취소하시겠습니까?",
  SELECT_QUESTION_TYPE: "문의 유형을 선택해 주세요.",
  INPUT_PCBANG_NAME: "PC방명을 입력해 주세요.",
  INPUT_REPRESENTATIVE_NAME: "대표자명을 입력해 주세요.",
  INPUT_PHONE_NUMBER: "연락처를 입력해 주세요.",
  INPUT_RIGHT_PHONE_NUMBER: "(-)를 제외한 숫자만 입력해 주세요.",
  INPUT_RIGHT_EMAIL: "이메일 형식을 확인해 주세요. (예: example@domain.com)",
  INPUT_TITLE: "최소 2자 이상 입력해 주세요.",
  INPUT_CONTENT: "문의 내용을 입력해 주세요.",
  FILE_SIZE_ERROR: "10MB 이하의 파일만 첨부 가능합니다.",
  FILE_MAX_LENGTH: "최대 3개의 파일까지만 첨부할 수 있습니다.",
  INPUT_INCIDENT_DATE: "사건발생일시를 입력해 주세요. 6개월 이내의 날짜만 입력 가능합니다.",
  SELECT_AFTER_STARTDATE: "종료일은 시작일 이후여야 합니다. 다시 입력해 주세요.",
  SELECT_GAME: "이용한 게임을 선택해 주세요.",
  SELECT_IP: "이용한 IP를 입력해 주세요.",
  INPUT_RIGHT_IP: "올바른 IP형식으로 입력해 주세요. (예: 123.123.123.123)",
  INPUT_DAMAGE_AMOUNT: "최소 1원 이상 입력해 주세요.",
  INPUT_RIGHT_DAMAGE_AMOUNT: "숫자만 입력해 주세요.",
  INPUT_DAMAGE_CONTENT: "피해 내용을 최소 10자 이상 입력해 주세요.",
  AGREE_3RD_PARTY_FOR_REPORT: "미납신고를 위한 개인정보 제 3자 제공에 동의해 주세요.",
  AGREE_PRIVACY_FOR_REPORT: "미납신고를 위한 개인정보 수집 및 이용에 동의해 주세요.",
  WITHDRAW_REPORT: "요청하신 미납자 신고를 취하합니다.",
};

const ACCOUNT = {
  INPUT_PCBANG_TYPE: "PC방 유형과 상호명을 입력해주세요.",
  INPUT_PCBANG_NAME: "PC방 상호명을 입력해주세요.",
  INPUT_REGISTRATION_NUMBER: "사업자등록 번호를 입력해주세요.",
  INPUT_RIGHT_REGISTRATION_NUMBER: "올바른 사업자등록 번호를 입력해주세요.",
  INPUT_REGISTRATION_FILE: "사업자 등록증을 등록해주세요.",
  REGISTRATION_FILE_ERROR: "등록 불가능한 파일 형식입니다.",
  INPUT_OPENING_DATE: "개업년월일을 입력해주세요.",
  AGREE_RECEIVE_EMAIL: "[이메일 수신 동의 / 마케팅 목적의 개인정보 수집 및 이용] {YYYY.MM.DD} 동의 처리 되었습니다.",
  WITHDRAW_RECEIVE_EMAIL: "[이메일 수신 동의 / 마케팅 목적의 개인정보 수집 및 이용] {YYYY.MM.DD} 동의 철회 되었습니다.",
  AGREE_RECEIVE_SMS: "[SMS 수신 동의 / 마케팅 목적의 개인정보 수집 및 이용] {YYYY.MM.DD} 동의 처리 되었습니다.",
  WITHDRAW_RECEIVE_SMS: "[SMS 수신 동의 / 마케팅 목적의 개인정보 수집 및 이용] {YYYY.MM.DD} 동의 철회 되었습니다.",
  AGREE_RECEIVE_EMAIL_SMS: "[이메일,SMS 수신 동의 / 마케팅 목적의 개인정보 수집 및 이용] {YYYY.MM.DD} 동의 처리 되었습니다.",
  WITHDRAW_RECEIVE_EMAIL_SMS: "[이메일,SMS 수신 동의 / 마케팅 목적의 개인정보 수집 및 이용] {YYYY.MM.DD} 동의 철회 되었습니다.",
};

export { COMMON, MANAGEMENT, PRODUCT, HELPDESK, ACCOUNT };
